<div class="cpp-tile-list__item-container">
  <h3 class="cpp-tile-list__heading">{{labels['dashboard.subscribe.title']}}</h3>
  <p class="cpp-tile-list__description">{{labels['dashboard.subscribe.body']}}</p>
  <a class="cpp-tile-list__button cpp-button" [routerLink]="['/', 'my-settings', 'subscriptions']">
    {{labels['dashboard.subscribe.button']}}
  </a>
</div>
